import * as React from 'react';
import * as SplitPane from 'react-flex-split-pane';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'redux';

import { changeCodeEditorWidth } from '../../actions/EditorActions/EditorActions';
import EditorCodeBarImport from '../../containers/Editor/EditorCodeBar';
import LearnSimulate from '../../containers/Editor/LearnSimulate';
import { StateType } from '../../reducers';
import { alphaPropertiesHasErrorsSelector } from '../../reducers/AlphaPropertiesReducer/AlphaPropertiesSelector';
import {
  activeTabIndexSelector,
  childTabsSelector,
  codeEditorWidthSelector,
  currentVisualization,
  editorOptionsSelector,
  getTabsSelector,
} from '../../reducers/EditorReducer/EditorSelector';
import { flashMessagesTopMessageSelector } from '../../reducers/FlashMessageReducer/FlashMessageSelector';
import { dataFetchingCheckSelector, fetchingSelectionCodeSelector } from '../../reducers/SimulationReducer/DataReducer/DataSelector';
import {
  filtersCodeSelector,
  filtersDataExplorerSelector,
  filtersLearnSelector,
  filtersResultsSelector,
  filtersSuperCodeSelector,
  filtersTutorialSelector,
} from '../../reducers/SimulationReducer/FiltersReducer/FiltersSelector';
import {
  fetchingPercentageSelector,
  fetchingPostSelector,
  percentageProgressSelector,
  showLearnBoxSelector,
} from '../../reducers/SimulationReducer/ProgressReducer/ProgressSelector';
import { isdeviceUpToTablet, isMobile } from '../../shared/helpers/responsive';

import { CodeEditor } from './';
import { EditorMainIfHasTabsStateProps, EditorMainProps, EditorMainState } from './types';
import SuperCodeEditor from './CodeEditor/SuperCodeEditor';
import SimulationMain from './Simulation/SimulationMain';
import { DataRoutesSimulate } from '../../containers/DataExplorer/DataRoutesSimulate';
import { EditorRouterFiltersManager } from './EditorRouterFiltersManager';
import { SIMULATE } from '../../shared/constants';
import { DATA_EXPLORER_SIMULATE_CLASSNAME } from '../../containers/DataExplorer/dataExplorerConfig';
import Tutorial from '../../containers/Tutorial/Tutorial';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EditorCodeBar = EditorCodeBarImport as any;

const HOCPanel =
  (panelsProps: any[], onChange: (size: any) => void, size: any, isResizing: boolean, onResizeStart: () => void, onResizeEnd: () => void) =>
  (components: JSX.Element[][]) => {
    if (components.length > 1) {
      return (
        // eslint-disable-next-line react/jsx-pascal-case
        <SplitPane.default
          className="split-simulation"
          onChange={onChange}
          size={size}
          isResizing={isResizing}
          onResizeStart={onResizeStart}
          onResizeEnd={onResizeEnd}
          maxSize={window.innerWidth - 600}
        >
          {components.map((Panel: any, key: number) => (
            <Panel key={key} {...panelsProps[key]} />
          ))}
        </SplitPane.default>
      );
    } else {
      return components.map((Panel: any, key: number) => <Panel key={key} {...panelsProps[key]} />);
    }
  };

type GenericProps = EditorMainProps & EditorMainIfHasTabsStateProps & RouteComponentProps<any>;
export class EditorMainIfHasTabsWithoutReducer extends React.Component<GenericProps, EditorMainState> {
  constructor(props: GenericProps) {
    super(props);
    this.state = {
      size: window.innerWidth / 2,
      isResizing: false,
      currentPercentageSize: 0.5,
    };
  }

  updateSize = () => {
    this.setState({ size: window.innerWidth * this.state.currentPercentageSize }, () => this.onResizeEnd());
  };

  resize = () => {
    this.setState({ isResizing: true }, () => this.updateSize());
    this.handleUpdateSize();
  };

  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  handleUpdateSize = () => {
    const popup: any = document.querySelector('.editor-panels');
    const settingsPopup: any = document.querySelector('.editor-top-bar-left__settings-popup');
    const alphaDetails: any = document.querySelector('.simulation .alphas-details-sections');
    const flashMessagesElm = document.getElementById('flashMessages');
    const flashHeight: number = flashMessagesElm ? flashMessagesElm.clientHeight : 0;
    const editorChildTabs = document.getElementById('editor-child-tabs');
    const editorChildTabsHeight: number = editorChildTabs && !isMobile('mobile') ? editorChildTabs.clientHeight : 0;
    const hasTopBar = !this.props.showSuperCode && isdeviceUpToTablet() ? 40 : this.props.showSuperCode && isMobile('mobile') ? 40 : 0;
    if (popup) {
      // 80 represent the top bar plus the settings
      popup.style['min-height'] = `calc(var(--full-dvh) - ${flashHeight + editorChildTabsHeight + 80 + hasTopBar}px)`;
      popup.style['max-height'] = `calc(var(--full-dvh) - ${flashHeight + editorChildTabsHeight + 80 + hasTopBar}px)`;
      if (settingsPopup) {
        settingsPopup.style['max-height'] = `calc(var(--full-dvh) - ${flashHeight + editorChildTabsHeight + 80 + hasTopBar}px)`;
      }
    }
    if (alphaDetails) {
      const detailsBar = isdeviceUpToTablet() ? 50 : 0;
      alphaDetails.style.height = `calc(var(--full-dvh) - ${flashHeight + editorChildTabsHeight + detailsBar + 140 + hasTopBar}px)`;
    }
  };

  componentDidMount() {
    this.handleUpdateSize();
  }

  componentDidUpdate(prevProps: any) {
    if (
      (prevProps.messages && !prevProps.messages.equals(this.props.messages)) ||
      this.props.activeTab !== prevProps.activeTab ||
      this.props.showSuperCode !== prevProps.showSuperCode ||
      this.props.currentMultiTabs.size !== prevProps.currentMultiTabs.size ||
      (!prevProps.messages && this.props.messages) ||
      this.props.showResults !== prevProps.showResults ||
      this.props.showCode !== prevProps.showCode ||
      this.props.showLearn !== prevProps.showLearn ||
      this.props.showDataExplorer !== prevProps.showDataExplorer ||
      this.props.showTutorial !== prevProps.showTutorial ||
      (!prevProps.data && this.props.data) ||
      (prevProps.data && !this.props.data)
    ) {
      this.handleUpdateSize();
    }
    const codeEditorWidth: any = document.querySelector('.editor-scrollable');
    const prevCodeEditorWidth = this.props.codeEditorWidth;
    if (codeEditorWidth && codeEditorWidth.offsetWidth !== prevCodeEditorWidth) {
      this.props.dispatchChangeCodeEditorWidth(codeEditorWidth.offsetWidth);
    }
  }

  onResizeStart = () => this.setState({ isResizing: true });
  onResizeEnd = () => this.setState({ isResizing: false });

  onChange = (size: any) => {
    this.setState(() => ({ size: size, currentPercentageSize: size / window.innerWidth }));
  };

  topBarProps = () => ({
    showPropertiesTabModal: this.props.showPropertiesTabModal,
    settingsOptions: this.props.settingsOptions,
    handleShowPropertiesTabModalState: this.props.handleShowPropertiesTabModalState,
  });

  bottomBarLeftProps = () => ({
    handleSimulate: this.props.handleSimulate,
    isMultiTab: this.props.isMultiTab,
    handleChangeVisualization: this.props.handleChangeVisualization,
    visualization: this.props.visualization,
    isFetching: this.props.fetchingPost || this.props.fetchingPercentage,
    isPythonCode: this.props.isPythonCode,
    handleExample: this.props.handleExample,
    showExample: !this.props.isMultiTab && !this.props.tabs.getIn([this.props.currentActiveTab, 'superAlpha']),
    isConsultant: this.props.isConsultant,
    isVisualization: this.props.isVisualization,
    emptyCode: this.props.emptyCode,
    currentActiveTab: this.props.currentActiveTab,
    path: this.props.path,
    tabs: this.props.tabs,
    data: this.props.data,
    currentChildActiveTab: this.props.currentChildActiveTab,
  });

  simulationProps = () => {
    const panels = this.getPanels();

    return {
      fullWidth: panels.learn === false && (panels.codeEditor === false || panels.superCodeEditor) ? true : false,
      fetchingPost: this.props.fetchingPost,
      simulatePercentage: this.props.simulatePercentage,
      fetchingPercentage: this.props.fetchingPercentage,
      data: this.props.data,
      handlerCancelSimulation: this.props.handlerCancelSimulation,
      isFetching: this.props.isFetching,
      path: this.props.path,
      showCode: this.props.showCode,
      showLearn: this.props.showLearn,
      showTutorial: this.props.showTutorial,
      showDataExplorer: this.props.showDataExplorer,
      shouldResize: this.state.isResizing,
      size: this.state.size,
      currentActiveTab: this.props.currentActiveTab,
      currentChildActiveTab: this.props.currentChildActiveTab,
      isMultiTab: this.props.isMultiTab,
      handleCheckSubmission: this.props.handleCheckSubmission,
      handleSubmitAlpha: this.props.handleSubmitAlpha,
      hasErrors: this.props.hasErrors,
      enabledIntro: this.props.enabledIntro,
    };
  };

  codeEditorProps = () => {
    const panels = this.getPanels();

    return {
      isSimulating: this.props.fetchingPercentage || this.props.fetchingPost,
      fullWidth: panels.learn === false && panels.simulation === false ? true : false,
      onCodeChange: this.props.onCodeChange,
      handleCloneAlpha: this.props.handleCloneAlpha,
      userId: this.props.userId,
      ...this.bottomBarLeftProps(),
      ...this.topBarProps(),
    };
  };

  superCodeEditorProps = () => {
    const panels = this.getPanels();

    return {
      isSimulating: this.props.fetchingPercentage || this.props.fetchingPost,
      fullWidth: panels.learn === false && panels.simulation === false ? true : false,
      onCodeChange: this.props.onCodeChange,
      handleCloneAlpha: this.props.handleCloneAlpha,
      userId: this.props.userId,
      ...this.bottomBarLeftProps(),
      ...this.topBarProps(),
    };
  };

  learnProps = () => {
    const panels = this.getPanels();

    return {
      fullWidth: !panels.codeEditor && !panels.simulation,
      currentActiveTab: this.props.currentActiveTab,
      currentChildActiveTab: this.props.currentChildActiveTab,
      isMultiTab: this.props.isMultiTab,
      checkIfTabIsEmptyCode: this.props.checkIfTabIsEmptyCode,
    };
  };

  tutorialProps = () => {
    const panels = this.getPanels();

    return {
      fullWidth: !panels.codeEditor && !panels.simulation,
      currentActiveTab: this.props.currentActiveTab,
      currentChildActiveTab: this.props.currentChildActiveTab,
      isMultiTab: this.props.isMultiTab,
      checkIfTabIsEmptyCode: this.props.checkIfTabIsEmptyCode,
    };
  };

  dataExplorerProps = () => {
    return {
      className: DATA_EXPLORER_SIMULATE_CLASSNAME,
      path: SIMULATE,
      currentActiveTab: this.props.currentActiveTab,
      currentChildActiveTab: this.props.currentChildActiveTab,
      isMultiTab: this.props.isMultiTab,
    };
  };

  getPanels = () => ({
    superCodeEditor: this.props.showSuperCode,
    codeEditor: this.props.showCode,
    simulation: this.props.showResults,
    learn: this.props.showLearn,
    tutorial: this.props.showTutorial,
  });

  learnComp = () => LearnSimulate;
  tutorialComp = () => Tutorial;
  codeEditorComp = () => CodeEditor;
  superCodeEditorComp = () => SuperCodeEditor;
  simulationComp = () => SimulationMain;
  dataExplorerComp = () => DataRoutesSimulate;

  renderPanels = () => {
    const panels: any = {
      superCodeEditor: this.props.showSuperCode,
      codeEditor: this.props.showCode,
      simulation: this.props.showResults,
      learn: this.props.showLearn,
      dataExplorer: this.props.showDataExplorer,
      tutorial: this.props.showTutorial,
    };
    let panelsProps: any = [];
    let panelsComps: any = [];
    Object.keys(panels).forEach((key: string) => {
      if (panels[key]) {
        const that = this as any;
        panelsProps = panelsProps.concat(that[`${key}Props`]());
        panelsComps = panelsComps.concat(that[`${key}Comp`]());
      }
    });

    return HOCPanel(panelsProps, this.onChange, this.state.size, this.state.isResizing, this.onResizeStart, this.onResizeEnd)(panelsComps);
  };

  render() {
    return (
      <div className="editor-instance">
        <div className="settings__mobile">
          <EditorCodeBar
            showPropertiesTabModal={this.props.showPropertiesTabModal}
            settingsOptions={this.props.settingsOptions}
            handleShowPropertiesTabModalState={this.props.handleShowPropertiesTabModalState}
          />
        </div>
        <EditorRouterFiltersManager />
        <div className="editor-panels">{this.renderPanels()}</div>
      </div>
    );
  }
}

const mapStateToProps = (state: StateType): EditorMainIfHasTabsStateProps => ({
  tabs: getTabsSelector(state),
  isFetching: dataFetchingCheckSelector(state),
  messages: flashMessagesTopMessageSelector(state),
  activeTab: activeTabIndexSelector(state),
  hasErrors: alphaPropertiesHasErrorsSelector(state),
  // @ts-expect-error connect own-props collapse under @types/react@19
  codeEditorWidth: codeEditorWidthSelector(state),
  showSuperCode: filtersSuperCodeSelector(state),
  showCode: filtersCodeSelector(state),
  showResults: filtersResultsSelector(state),
  showLearn: filtersLearnSelector(state),
  showDataExplorer: filtersDataExplorerSelector(state),
  showTutorial: filtersTutorialSelector(state),
  visualization: currentVisualization(state),
  settingsOptions: editorOptionsSelector(state),
  fetchingPost: fetchingPostSelector(state) || fetchingSelectionCodeSelector(state),
  isMultiTab: childTabsSelector(state),
  showLearnBox: showLearnBoxSelector(state),
  simulatePercentage: percentageProgressSelector(state),
  fetchingPercentage: fetchingPercentageSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchChangeCodeEditorWidth: (width: number) => dispatch(changeCodeEditorWidth(width)),
});

export const EditorMainIfHasTabs = compose<any>(
  withRouter,
  connect<any, any, any, StateType>(mapStateToProps, mapDispatchToProps)
)(EditorMainIfHasTabsWithoutReducer);
